import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Home } from 'lucide-react';

export default function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#fafaf8' }} data-testid="not-found-page">
            <div className="text-center max-w-sm">
                <p className="text-6xl font-heading mb-4" style={{ color: '#d4d4d4' }}>404</p>
                <h1 className="font-heading text-xl mb-2" style={{ color: '#1a1a1a' }}>Page not found</h1>
                <p className="text-sm mb-8" style={{ color: '#888' }}>The page you're looking for doesn't exist or has been moved.</p>
                <div className="flex items-center justify-center gap-3">
                    <Button
                        variant="outline"
                        className="rounded-xl"
                        onClick={() => navigate(-1)}
                        data-testid="go-back-btn"
                    >
                        <ArrowLeft className="w-4 h-4 mr-1.5" />
                        Go Back
                    </Button>
                    <Button
                        className="rounded-xl"
                        style={{ background: '#10b981', color: 'white' }}
                        onClick={() => navigate('/')}
                        data-testid="go-home-btn"
                    >
                        <Home className="w-4 h-4 mr-1.5" />
                        Home
                    </Button>
                </div>
            </div>
        </div>
    );
}
